import React, { useState, useEffect } from 'react';
import { Button, Col, Row, InputGroup, Form } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';

const BotaoSacola = ({ loading, empresa, botao }) => {
  const [total, setTotal] = useState(0);
  const [quantidade, setQuantidade] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const {
    buscarDadosPorId
  } = useProvider();
  
  const totalComDesconto = parseFloat(total || 0) - parseFloat(desconto || 0);
  const totalComDescontoFormatado = totalComDesconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const totalOriginal = parseFloat(total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  
  useEffect(() => {
    const buscarSacola = async () => {
      try {
        const response = await buscarDadosPorId("local_registros", 'sacola');
        if (response) {
          const itens = response.itens.filter(x => x.produto.empresa === empresa.id);
          const quantidade = itens.reduce((acc, x) => acc + x.quantidade, 0);
          const total = itens.reduce((acc, x) => acc + (x.produto.preco_unitario * x.quantidade), 0);
  
          setQuantidade(quantidade);
          setTotal(total);
          setDesconto(response[0].desconto);
        }
      } catch (err) {
        console.error('Erro ao buscar sacola:', err);
      }
    };
  
    buscarSacola();
  }, [empresa, setQuantidade, setTotal, setDesconto]);
  
  return (
    <>
      {quantidade > 0 && (
        <div className="bs-floating shadow navbar-light">
          <div className="container py-3" onClick={()=>botao?.onClick()}>
            <Row>
              <Col><i class="bi bi-handbag fs-5"></i>{quantidade}</Col>
              <Col className="text-center">Ver pedido</Col>
              <Col className="text-end">
                {parseFloat(desconto || 0) > 0 && (
                    <s className="small px-1">{totalOriginal}</s>
                )}
                {totalComDescontoFormatado}
              </Col>
            </Row>
          </div>
        </div>
      )}
    </>
  );
};

export default BotaoSacola;